import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

const ImageSlider = ({ banners = [] }) => { // Default to an empty array if banners is undefined
  return (
    <Slider {...sliderSettings}>
      {banners.map((banner, index) => (
        <div key={index} className="flex justify-center items-center">
          <img
            loading="lazy"
            src={banner}
            alt={`Banner ${index}`}
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      ))}
    </Slider>
  );
};

export default ImageSlider;
